import {charcoal} from '../sass/base/_exports.sass';

export const ClipboardIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 37;
  const height = 40;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <path
        d="M28.5 0V4H34.514C35.61 4 36.5 4.89 36.5 5.986V38.014C36.5 39.11 35.61 40 34.514 40H2.486C1.39 40 0.5 39.11 0.5 38.014V5.986C0.5 4.89 1.39 4 2.486 4H8.5V0H28.5ZM8.5 8H4.5V36H32.5V8H28.5V12H8.5V8ZM12.5 28V32H8.5V28H12.5ZM12.5 22V26H8.5V22H12.5ZM12.5 16V20H8.5V16H12.5ZM24.5 4H12.5V8H24.5V4Z"
        fill={color}
      />
    </svg>
  );
};
